<template>
  <div class="row mb-5 b-form__container_type_flex b-form__row_type_flex-end">
    <div class="col-3" :class="{'col-6': isPopup}">
      <div>
        <label>{{$t('CONTENT.assets.expenses_type')}}:</label>
        <cool-select :list="types"
                     option-value="type"
                     option-text="name"
                     :placeholder="$t('CONTENT.choose')"
                     v-model="type"
        ></cool-select>
      </div>
    </div>
    <div class="col-2" :class="{'col-4': isPopup}">
      <div>
        <label>{{$t('CONTENT.sum')}} ({{currencyCode}}):</label>
        <numeric class="b-numeric" controls :min="-1000000000000" :max="1000000000000" v-model="sum"></numeric>
      </div>
    </div>
    <button type="button" class="b-btn b-btn_border_none" @click="deleteExpensesItem(expensesItemIndex)">
      <dynamic-icon class="b-btn__icon" icon="close"></dynamic-icon>
    </button>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      expensesItem: {
        type: Object,
      },
      expensesItemIndex: {
        type: Number,
      },
      assetComponent: {
        type: Object,
      },
      isPopup: {
        type: Boolean
      }
    },
    data() {
      return {
        types: [
          {
            type: 'first_expenses',
            name: this.$t('CONTENT.assets.first_expenses')
          },
          {
            type: 'future_expenses',
            name: this.$t('CONTENT.assets.future_expenses')
          }
        ]
      }
    },
    computed: {
      ...mapGetters(["getContractSettings"]),
      currencyCode() {
        return this.getContractSettings.currencyCode;
      },
      sum: {
        get() {
          if (this.expensesItem.sum !== null) {
            return this.expensesItem.sum;
          }
        },
        set(newVal) {
          this.expensesItem.sum = newVal;

          this.$store.commit("assetComponentsPlugin/updateAssetComponentExpenses", {
            expensesItem: this.expensesItem,
            assetComponent: this.assetComponent,
          });
        }
      },
      type: {
        get() {
          if (this.expensesItem.type !== null) {
            return this.expensesItem.type;
          }
        },
        set(newVal) {
          this.expensesItem.type = newVal;

          this.$store.commit("assetComponentsPlugin/updateAssetComponentExpenses", {
            expensesItem: this.expensesItem,
            assetComponent: this.assetComponent,
          });
        }
      }
    },
    methods: {
      deleteExpensesItem(itemIndex) {
        this.$emit('onDeleteExpenses', itemIndex, this.expensesItem);
      },
    }
  }
</script>
